/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React from 'react';

const WorkInprogressSVG = () => (
  <svg
    width="75"
    height="73"
    viewBox="0 0 75 73"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="UnderCons">
      <path
        id="Path"
        d="M38.8841 0.0996516C38.764 0.423721 37.787 0.647846 36.5708 0.647846C35.315 0.647846 34.3156 0.289188 34.2484 0L28.5519 15.7583H28.5506C28.5534 17.0067 32.1435 18 36.5506 18C40.9574 18 44.5506 17.0392 44.5506 15.8175V15.8171L38.8841 0.0996516Z"
        className="workinprogress-primary2-svg"
      />
      <path
        id="Path_2"
        d="M70.507 52.9201L56.4637 48L59.0233 55.2421C59.0157 58.6971 49.1691 61.4542 37.024 61.4542C24.8785 61.4542 15.0322 58.6971 15.0247 55.2421H15.0288L17.5879 48.0011L5.17742 52.9201C-1.33354 54.9364 -1.52296 56.9281 3.595 59.2357L28.653 70.2993C35.3111 73.3014 38.241 73.2983 44.8952 70.2993L70.507 59.2439C75.632 56.9342 77.0393 54.9389 70.507 52.9201Z"
        className="workinprogress-primary1-svg"
      />
      <g id="Group">
        <path
          id="Path_3"
          d="M45.5638 15.9848C45.5373 17.2083 41.9462 18.1687 37.5449 18.1687C33.1834 18.1687 29.6204 17.1939 29.5276 15.9596L19.7025 43.3385C19.702 43.3374 19.7013 43.3364 19.7009 43.3354L15.5615 54.8777H15.5574C15.565 58.2789 25.4003 60.993 37.5323 60.993C49.664 60.993 59.4996 58.2789 59.5069 54.8777H59.5072H59.5102L45.5638 15.9848Z"
          fill="white"
        />
        <path
          id="Path_4"
          d="M35.2829 0.0949508L35.2832 0.0859613L35.2815 0.0907771C35.2818 0.0922218 35.2824 0.0936666 35.2829 0.0949508Z"
          fill="white"
        />
      </g>
      <path
        id="Path_5"
        d="M50.2646 29C49.8933 29.8625 48.5914 30.6066 46.4429 31.174C44.0648 31.8019 40.8999 32.1478 37.5313 32.1478C34.1615 32.1478 30.9965 31.794 28.6192 31.1515C26.5398 30.5896 25.2531 29.8592 24.8361 29.0149L19.5539 43.184H19.5506C19.5567 45.7333 27.6484 48 37.5506 48C47.4526 48 55.5506 45.8391 55.5506 43.1777V43.1768L50.2646 29Z"
        className="workinprogress-primary2-svg"
      />
    </g>
  </svg>
);

const ServerErrorSVG = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M62.7368 0H33.2632V9.44751H62.7368V0Z"
      className="server-error-svg server-error-SVG"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 15.221C25.91 15.221 8 33.0815 8 55.1105C8 77.1395 25.91 95 48 95C70.09 95 88 77.1395 88 55.1105C88 44.5606 83.8922 34.9667 77.1849 27.8329L82.5928 21.9531L75.6112 15.5671L69.929 21.745C63.6316 17.6204 56.0966 15.221 48 15.221ZM44.4557 29.864H53.5696V58.1401H44.4557V29.864Z"
      className="server-error-SVG"
    />
  </svg>
);

const OTPErrorSVG = () => (
  <svg
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M74.1667 38.1081V25.7297C74.1667 11.5458 62.6556 0 48.5 0C34.3476 0 22.8333 11.5458 22.8333 25.7297V38.1081C15.7461 38.1081 10 43.8684 10 50.973V83.1351C10 90.2398 15.7461 96 22.8333 96H74.1667C81.2539 96 87 90.2398 87 83.1351V50.973C87 43.8684 81.2539 38.1081 74.1667 38.1081ZM51.7083 69.2841V79.9189C51.7083 81.6967 50.2734 83.1351 48.5 83.1351C46.7266 83.1351 45.2917 81.6967 45.2917 79.9189V69.2841C43.4086 68.1659 42.0833 66.1935 42.0833 63.8378C42.0833 60.2823 44.9564 57.4054 48.5 57.4054C52.0436 57.4054 54.9167 60.2825 54.9167 63.8378C54.9167 66.1935 53.5914 68.1659 51.7083 69.2841ZM61.3333 38.1081H35.6667V25.7297C35.6667 18.6313 41.4222 12.8649 48.5 12.8649C55.5746 12.8649 61.3333 18.6315 61.3333 25.7297V38.1081Z"
      fill="#CC0000"
    />
  </svg>
);

const SessionTimeoutSVG = () => (
  <svg
    width="85"
    height="96"
    viewBox="0 0 85 96"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.5 0H28.5V9.14286H56.5V0ZM37.8333 32V59.4286H47.1667V32H37.8333ZM81.9333 22.72L75.3067 29.2114C81.0467 36.2514 84.5 45.1657 84.5 54.8571C84.5 77.5771 65.74 96 42.5 96C19.26 96 0.5 77.5771 0.5 54.8571C0.5 32.1371 19.3067 13.7143 42.5 13.7143C52.3933 13.7143 61.4933 17.0971 68.7267 22.7657L75.3533 16.2743C77.7333 18.1943 79.9267 20.3886 81.9333 22.72Z"
      fill="#999999"
    />
  </svg>
);

const NoResultsFound = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M78.2456 68.651L61.6347 52.0401C65.1268 46.7432 67.1648 40.4023 67.1652 33.5826C67.1652 27.2792 65.4247 21.3835 62.4037 16.3438L55.3168 23.4302C56.7599 26.514 57.5702 29.9529 57.5702 33.5822C57.5697 46.83 46.831 57.5697 33.5826 57.5702C29.9533 57.5702 26.514 56.7599 23.4302 55.3168L16.3438 62.4032C21.3831 65.4247 27.2787 67.1652 33.5826 67.1652C40.4393 67.1652 46.8127 65.1057 52.1274 61.578L69.4282 78.2307C71.3295 80.06 74.3466 79.9688 76.1332 78.0268L78.3895 75.5738C80.1761 73.6318 80.1113 70.5168 78.2456 68.651Z"
      className="no-results-found-cirle"
    />
    <path
      d="M11.8484 43.7341C10.4053 40.6508 9.5955 37.2124 9.5955 33.5831C9.59502 20.3352 20.3343 9.5955 33.5831 9.59502C37.2124 9.59502 40.6508 10.4053 43.7346 11.8484L50.821 4.76153C45.7817 1.74054 39.8865 0 33.5831 0C15.0354 0.000479751 0.000479751 15.0354 0 33.5826C0 39.886 1.74006 45.7817 4.76153 50.8215L11.8484 43.7341Z"
      className="no-results-found-cirle"
    />
    <path
      d="M62.3671 6.02255e-05L0 62.3672L4.79742 67.1646L67.1645 4.79748L62.3671 6.02255e-05Z"
      className="no-results-found-line"
    />
  </svg>
);

const LongTimeErrorImg = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.332 6.76562V13.499C57.9654 15.299 68.332 28.599 66.532 43.2323C64.9987 55.3656 55.4654 64.999 43.332 66.4323V73.099C61.6654 71.2656 74.9987 54.999 73.1654 36.6656C71.6654 20.8323 59.0987 8.33229 43.332 6.76562Z"
      className="clock-left-main-section"
    />
    <path
      d="M41.668 40.832V23.332H36.668V43.332L54.168 53.832L56.668 49.732L41.668 40.832Z"
      className="clock-left-main-section"
    />
    <path
      d="M18.9007 14.2005C23.9673 10.0005 30.1673 7.50052 36.6673 6.86719V13.5339C31.9007 14.2005 27.4007 16.1339 23.6673 19.1339L18.9007 14.2005Z"
      className="clock-left-dot-section"
    />
    <path
      d="M6.83398 36.6672C7.46799 30.1441 10.0328 23.9583 14.2007 18.9005L18.9673 23.6672C16.0007 27.4339 14.134 31.9339 13.5007 36.6672H6.83398Z"
      className="clock-left-dot-section"
    />
    <path
      d="M14.234 61.1005C10.1007 56.0339 7.53398 49.8672 6.86732 43.3339H13.534C14.1472 48.0759 16.0238 52.5659 18.9673 56.3339L14.234 61.1005Z"
      className="clock-left-dot-section"
    />
    <path
      d="M18.9004 65.7971L23.6671 61.2305C27.4351 64.174 31.9251 66.0506 36.6671 66.6638V73.3305C30.1313 72.6272 23.9497 70.0061 18.9004 65.7971Z"
      className="clock-left-main-section"
    />
  </svg>
);

export {
  ServerErrorSVG,
  WorkInprogressSVG,
  OTPErrorSVG,
  SessionTimeoutSVG,
  NoResultsFound,
  LongTimeErrorImg,
};
